export enum serviceOrderTypeEnum {
    IMPLANTATION = 'INSTALAÇAO',
    ERROR = 'ERRO',
    CORRECTION = 'CORREÇAO',
    MIGRATION_DB = 'MIGRAÇAO DB',
    SUGESTION = 'SUGESTAO',
    ATUALIZATION = 'ATUALIZAÇAO',
    CANCELATION = 'CANCELAMENTO DE SISTEMA',
    INSTALLATION_MP = 'INSTALAÇAO MP',
    TEF = 'TEF',
}
